var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnChain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 8,
    viewBox: "0 0 20 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.78112 4C1.78112 2.72081 2.87554 1.68528 4.22747 1.68528H9.03433V0H4.22747C1.88841 0 0 1.7868 0 4C0 6.2132 1.88841 8 4.22747 8H9.03433V6.31472H4.22747C2.87554 6.31472 1.78112 5.27919 1.78112 4ZM15.7725 0H10.9657V1.68528H15.7725C17.1245 1.68528 18.2189 2.72081 18.2189 4C18.2189 5.27919 17.1245 6.31472 15.7725 6.31472H10.9657V8H15.7725C18.1116 8 20 6.2132 20 4C20 1.7868 18.1116 0 15.7725 0ZM4.91416 4C4.91416 4.46701 5.32189 4.85279 5.81545 4.85279H14.206C14.6996 4.85279 15.1073 4.46701 15.1073 4C15.1073 3.53299 14.6996 3.14721 14.206 3.14721H5.81545C5.32189 3.14721 4.91416 3.53299 4.91416 4Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnChain);
export default __webpack_public_path__ + "static/media/icn_chain.6693761b865ee0265ee71574f14a6c53.svg";
export { ForwardRef as ReactComponent };